export default __webpack_public_path__ + "img/MaMyZMXi.14852fa1.svg";